/*
   CAROUSEL SCROLL BUTTONS

   To implement buttons for scrolling on carousels:
   1. Add the class '.Arrow-slide-left' and '.Arrow-slide-right' to the buttons
   2. Add the class '.Arrow-carousel-container' to the parent element that contains both the carousel itself and the buttons
   3. Add the class '.Arrow-carousel' to the carousel itself
*/

// Function to initialize the carousel
function initializeCarousels() {
  const rightButtons = document.querySelectorAll('.Arrow-slide-right');
  const leftButtons = document.querySelectorAll('.Arrow-slide-left');
  const carousels = document.querySelectorAll('.carousel');

  function scrollCarousel(direction, carousel) {
    const scrollAmount = carousel.offsetWidth * 0.8; // Scroll 80% of the carousel's visible width
    carousel.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth"
    });
  }

// Function to add event listeners to scroll buttons
  function addScrollListener(buttons, direction) {
    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const carouselContainer = button.closest('.Arrow-carousel-container');
        const carousel = carouselContainer.querySelector('.Arrow-carousel');
        scrollCarousel(direction, carousel);
      });
    });
  }

// Add event listeners for left and right buttons
  addScrollListener(rightButtons, 1);
  addScrollListener(leftButtons, -1);

  carousels.forEach(carousel => {
    let isDragging = false,
      startX,
      scrollLeft,
      dragged;

    const snapCarousel = carousel.classList.contains('carousel-snap');

    const startDrag = (e) => {
      if (snapCarousel) {
        carousel.classList.remove('carousel-snap');
      }
      e.preventDefault();
      isDragging = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      dragged = false;
      carousel.style.scrollBehavior = 'auto'; // Disable smooth scrolling during drag
    };

    const endDrag = () => {
      isDragging = false;
      carousel.style.scrollBehavior = 'smooth'; // Re-enable smooth scrolling after drag
      if (snapCarousel) {
        carousel.classList.add('carousel-snap');
      }
    };

    const drag = (e) => {
      if (! isDragging) return;
      


      const x = e.pageX - carousel.offsetLeft;
      const walk = x - startX;
      carousel.scrollLeft = scrollLeft - walk;
      if (Math.abs(walk) > 5) {
        dragged = true;
      }
    };

    const handleClick = (e) => {
      if (dragged && e.target.closest('a')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    };

// Mouse events
    carousel.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', endDrag);
    carousel.addEventListener('mouseleave', endDrag);

// Prevent click on dragged items
    carousel.addEventListener('click', handleClick, true);
  });
}

// Initialize carousels on page load
document.addEventListener('DOMContentLoaded', initializeCarousels);


// Replace variant in product card when clicking on thumbnail
const productThumbnails = document.querySelectorAll('.product-card-thumbnail-image-wrapper');


// Function to change all relevant elements on product card when variant is changed
productThumbnails.forEach(thumbnail => {
  thumbnail.addEventListener("click", async (e) => {
    e.preventDefault();

    const selectedNode = e.currentTarget;
    const selectedCard = selectedNode.closest('.product-card');
    const selectedCardVariantImage = selectedCard.querySelector('.product-card-variant-image');
    const selectedCardLifestyleImage = selectedCard.querySelector('.product-card-lifestyle-image');
    const selectedCardVariantPrice = selectedCard.querySelector('.product-card-price-span');
    const selectedCardVariantPriceVaries = selectedCard.querySelector('.product-card-price-varies-span');
    const selectedCardLinks = selectedCard.querySelectorAll('.product-card-link-wrapper');
    const selectedNodeURL = selectedNode.href;
    const selectedID = selectedNode.id;

// add selected class to selected variant thumbnail
    const previousSelected = selectedCard.querySelector('.selected');
    if (previousSelected) {
      previousSelected.classList.remove('selected');
    }
    selectedNode.classList.add('selected');

// update card links
    selectedCardLinks.forEach(link => {
      link.setAttribute('href', selectedNodeURL);
    });

// Update image
    const newImage = selectedNode.getAttribute('data-variant-image');
    selectedCardVariantImage.src = newImage;
    selectedCardVariantImage.srcset = newImage;

// Update price
    const newPrice = selectedNode.getAttribute('data-variant-price');
    selectedCardVariantPrice.textContent = newPrice;

// Remove "From ..."
    if (selectedCardVariantPriceVaries) {
      selectedCardVariantPriceVaries.remove();
    }
// remove lifestyle image
    if (selectedCardLifestyleImage) {
      selectedCardLifestyleImage.remove();
    }


  })
})